import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {DragAndDropHandler} from "../../utils/DragAndDropHandler";

declare var ko: any;

export class mailingList_template extends vnTemplate {


    //As VM
    protected filter: filterSimple_template;
    protected resultInfos: resultsInfo_template;
    protected pagination: pagination_template;

    private originalSortables: any;

    protected initPartial() {

        this.filter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);
        this.resultInfos = new resultsInfo_template('resultInfo', this.getTemplateViewModel(), this.caller);
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
    }

    public getViewModelForRequest(): any {
        return {
            orderBy: this.getTemplateViewModel().orderBy,
            orderByDirection: this.getTemplateViewModel().orderByDirection,
            orderByAndDirection: this.getTemplateViewModel().orderByAndDirection,
            pagination: this.getTemplateViewModel().pagination,
            filters : {
                keywords : this.getTemplateViewModel().filter.filterKeyword
            },
        }
    }

    protected buildViewModel(): any {
        let self = this
        return {
            mailingLists: ko.observableArray([]),
            orderBy: ko.observable("id"),
            orderByDirection: ko.observable("DESC"),
            orderByAndDirection: ko.observable("id_DESC"),
            idMailingListToDelete: ko.observable(null),
            isPopUpVisible: ko.observable(false),
            isEditRestricted: ko.observable(false)
            // ,originalSortables:ko.observableArray([])
            ,sortables:ko.observableArray([])
            ,onClickReorder: (value, data, event) => {
                self.onClickReorder(value, data, event);
            },
            viewMailingList: (data, event) => {
                self.viewMailingList(data.id, event);
            },
            onClickAdd: (data, event) => {
                self.onClickAdd()
            },
            onClickShowPopUp:function (data, event) {
                self.showPopUp();
            },
            onClickClosePopUp: function (data, event) {
                self.closePopUp();
            },
            onClickSavePopUp:function (data, event) {
                self.updateListPositions();
            },
            handleDragAndDrop: function(element, currentObservableArray ,childrenSelector){
                self.handleDragAndDrop(element, currentObservableArray ,childrenSelector);
            },
        }
    }

    protected getTemplateHtml(): string {
        return `

        <div class="list-header w-justify">
            <div class="w-left" >
                    <button data-bind="event: {click: onClickAdd}, visible: !isEditRestricted()" class="btn secondary icon i-add" type="button">Create Mailing List</button>    
                    <button data-bind="event: {click: onClickShowPopUp}" class="btn secondary icon i-settings" type="button">Config</button>
            </div>
            <div class="w-center">
                <div class="w-filter-keyword" data-bind="template: { name: 'filterSimple-template', data: filter }">
                    <div class="w-search-feild icon i-search2">
                        <input data-bind="textInput: filterKeyword, event: { keyup: onKeyUpFilterAction}, valueUpdate : 'afterkeydown'" type="input" class="search-feild">
                        <input data-bind="value: filterKeywordLastKeyPress" type="hidden">
                        <input date-bind="value: filterKeywordRequestedKeyWord" type="hidden">
                        <button data-bind="event: { click: onClearInput }, css: { 'is-showing' : filterInputClearButton }" class="btn-sec icon i-close" id="close-btn" type="button"></button>
                    </div>
                </div>
            </div>
            <div class="w-right">
                ` + this.pagination.getHtmlBuild() + `
            </div>
        </div>

        <div class="w-list-results" id="list-results">
            <table class="list-results">
            ` + this.resultInfos.getHtmlBuild() + `
                <thead>
                    <tr>
                        <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'id') }, css: { 'list-sort-desc': orderByAndDirection()=='id_DESC', 'list-sort-asc': orderByAndDirection()=='id_ASC' }">ID</span></th>
                        <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'name') }, css: { 'list-sort-desc': orderByAndDirection()=='name_DESC', 'list-sort-asc': orderByAndDirection()=='name_ASC' }">Title</span></th>
                        <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'description') }, css: { 'list-sort-desc': orderByAndDirection()=='description_DESC', 'list-sort-asc': orderByAndDirection()=='description_ASC' }">Description</span></th>
                        <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'reference') }, css: { 'list-sort-desc': orderByAndDirection()=='reference_DESC', 'list-sort-asc': orderByAndDirection()=='reference_ASC' }">Reference</span></th>
                        <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'isPrimary') }, css: { 'list-sort-desc': orderByAndDirection()=='isPrimary_DESC', 'list-sort-asc': orderByAndDirection()=='isPrimary_ASC' }">Is Primary</span></th>
                        <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'welcomeEmailId') }, css: { 'list-sort-desc': orderByAndDirection()=='welcomeEmailId_DESC', 'list-sort-asc': orderByAndDirection()=='welcomeEmailId_ASC' }">Welcome Email</span></th>
                        <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'unsubscriptionEmailId') }, css: { 'list-sort-desc': orderByAndDirection()=='unsubscriptionEmailId_DESC', 'list-sort-asc': orderByAndDirection()=='unsubscriptionEmailId_ASC' }">unsubscription Email</span></th>
                        <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'isActive') }, css: { 'list-sort-desc': orderByAndDirection()=='isActive_DESC', 'list-sort-asc': orderByAndDirection()=='isActive_ASC' }">Active</span></th>
                        <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'isDefault') }, css: { 'list-sort-desc': orderByAndDirection()=='isDefault_DESC', 'list-sort-asc': orderByAndDirection()=='isDefault_ASC' }">Is Default</span></th>
                        <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateCreated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateCreated_DESC', 'list-sort-asc': orderByAndDirection()=='dateCreated_ASC' }">Date Created</span></th>
                        <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateUpdated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateUpdated_DESC', 'list-sort-asc': orderByAndDirection()=='dateUpdated_ASC' }">Date Updated</span></th>
                    </tr>
                </thead>
                <tbody data-bind="foreach: mailingLists">
                    <tr class="cursor">
                        <td data-bind="event: { click: $parent.viewMailingList }"><a class="right-click" data-bind="attr: {href: emakiView}"><span data-bind="text: id"></span></a></td>
                        <td data-bind="event: { click: $parent.viewMailingList }"><a class="right-click" data-bind="attr: {href: emakiView}"><span data-bind="text: name"></span></a></td>
                        <td data-bind="event: { click: $parent.viewMailingList }"><a class="right-click" data-bind="attr: {href: emakiView}"><span data-bind="text: description"></span></a></td>
                        <td data-bind="event: { click: $parent.viewMailingList }"><a class="right-click" data-bind="attr: {href: emakiView}"><span data-bind="text: reference"></span></a></td>
                        <td data-bind="event: { click: $parent.viewMailingList }"><a class="right-click" data-bind="attr: {href: emakiView}"><span data-bind="text: isPrimary"></span></a></td>
                        <td data-bind="event: { click: $parent.viewMailingList }"><a class="right-click" data-bind="attr: {href: emakiView}"><span data-bind="text: (welcomeEmailId != null) ? welcomeEmailSubject + ' (ID: ' + welcomeEmailId + ')' : ''"></span></a></td>
                        <td data-bind="event: { click: $parent.viewMailingList }"><a class="right-click" data-bind="attr: {href: emakiView}"><span data-bind="text: (unsubscriptionEmailId != null) ? unsubscriptionEmailSubject + ' (ID: ' + unsubscriptionEmailId + ')' : ''"></span></a></td>
                        <td data-bind="event: { click: $parent.viewMailingList }"><a class="right-click" data-bind="attr: {href: emakiView}"><span data-bind="text: isActive"></span></a></td>
                        <td data-bind="event: { click: $parent.viewMailingList }"><a class="right-click" data-bind="attr: {href: emakiView}"><span data-bind="text: isDefault"></span></a></td>
                        <td data-bind="event: { click: $parent.viewMailingList }"><a class="right-click" data-bind="attr: {href: emakiView}"><span data-bind="text: dateCreated"></span></a></td>
                        <td data-bind="event: { click: $parent.viewMailingList }"><a class="right-click" data-bind="attr: {href: emakiView}"><span data-bind="text: dateUpdated"></span></a></td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div data-bind="css: { 'is-visible': isPopUpVisible }" class="w-lightbox light-theme lightbox-embed">
            <div class="lightbox-content mailing-list">
                <div class="w-form lightbox-form">

                    <div class="form-header">
                        <h3 class="form-title icon i-settings">Config Form</h3>
                        <button type="button" class="close-button icon i-close-2" data-bind="event: { click: onClickClosePopUp }" ></button>
                    </div>

                    <div id="sortable_list" class="form-body-scroll">

                        <div class="" data-bind="visible: sortables().length == 0">
                            <span style="margin:2rem auto; display: block;background: #fffae6;padding: 1rem;max-width: 400px;border: 1px dashed #e4d8ab;"> There are no mailing list available</span>
                        </div>

                        <table id="spec_section_list" class="list-action full-width" data-bind="visible: sortables().length >= 1">
                            <thead>
                                <tr style="background-color:transparent">
                                    <th class="short"></th>
                                    <th><span>ID</span></th>
                                    <th><span>Title</span></th>
                                    <th><span>Default</span></th>
                                    <th><span>Active</span></th>
                                </tr>
                            </thead>
                            <tbody data-bind="foreach: sortables, childrenComplete : handleDragAndDrop($element, sortables ,'.form-row')" >
                                <tr class="form-row" data-bind="css:{ 'is-active' : isActive}">
                                    <td class="drag-handle i-move short"><button type="button" class="btn no-bg icon i-drag"></button></td>
                                    <td><span data-bind="text: id"></td>
                                    <td><span data-bind="text: name"></td>
                                    <td>
                                        <input type="checkbox" value="1" data-bind="enable: false, checked: $data.isDefault, attr:{id: 'isDefault_' + $index()}"/>
                                        <label data-bind="attr:{for: 'isDefault_' + $index()}" class="form-label icon i-check"></label>
                                    </td>
                                    <td>
                                        <input type="checkbox" value="1" data-bind="enable: $parent.isEditRestricted(), checked: $data.isActive, attr:{id: 'isActive_' + $index()}"/>
                                        <label data-bind="attr:{for: 'isActive_' + $index()}" class="form-label icon i-check"></label>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="form-footer">
                        <button type="button" data-bind="event: { click: onClickClosePopUp }" class="btn ">Cancel</button>
                        <button type="button" data-bind="event: { click: onClickSavePopUp }" class="btn highlight">Save</button>
                    </div>
                </div>
            </div>
        </div>
        `;
    }

    protected getTemplateName(): string {
        return "mailingList-template";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-content"];
    }

    protected getMainElementType(): string {
        return "div";
    }

    public setResultInfo(nbResults, nbPages, execTime) {

        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

    protected viewMailingList(data, event): any {
        this.caller.viewMailingList(data)
    }

    protected onClickReorder(value, data, event): any {

        data.orderBy(value);
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.mailingListsListReorder();
    }

    protected onClickAdd(): any {
        this.caller.addMailingList()
    }
    //Action on view model
    public setMailingLists(mailingLists, brandId?) {

        mailingLists.forEach((ml) => ml['emakiView'] = '/brand/' + brandId + '/newsletter/mailing-lists/view/' + ml.id);

        this.getTemplateViewModel().mailingLists(mailingLists);
    }

    //methods for reorder positions
    protected closePopUp(): any {

        this.getTemplateViewModel().isPopUpVisible(false)
    }
    protected showPopUp(): any {

        this.caller.filterList('config'); //to reset them based on position
        this.getTemplateViewModel().isPopUpVisible(true);
    }

    protected updateListPositions(){

        let sortables = this.getTemplateViewModel().sortables();

        for (var i = 0; i < sortables.length; i++) {

            sortables[i].position = i + 1;
        }

        this.caller.bulkSave(sortables);
    }


    public setEditRestricted(flag: boolean){
        this.getTemplateViewModel().isEditRestricted(flag);
    }

    public setSortables(sortables){

        this.getTemplateViewModel().sortables(sortables);
    }

    public handleDragAndDrop(element, currentObservableArray ,childrenSelector): any {

        DragAndDropHandler.handleDragAndDrop(element, currentObservableArray ,childrenSelector);
    }

}




// WEBPACK FOOTER //
// ./js/components/templates/mailingList_template.ts